<template>
  <div id="contenedor">
    <v-layout row wrap="">
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
                <v-icon style="margin-left:30px; margin-top:25px" color="white" x-large="">mdi-ab-testing</v-icon>
            </v-card>
            <div class="usuario">FRASES POR DEFECTO</div>
              <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"><v-icon color="white">mdi-plus-thick</v-icon></v-btn>
              </template>
                <v-card>
                  <v-card-title class="nav">
                      <span class="headline" style="color:white"><v-icon color="white">mdi-ab-testing</v-icon> {{ formTitle }}</span>
                  </v-card-title>
                  <!-- componente del modal para agregar y actualizar -->
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="editedItem.frase" label="Frase"></v-text-field>
                          </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                  <v-card-actions>
                    <v-spacer></v-spacer>
                      <v-btn color="#1D3C7F"  dark @click="close">Cancelar</v-btn>
                      <v-btn
                      color="#1D3C7F"
                      dark
                      @click="save"
                      :disabled="!editedItem.frase"
                      >Guardar</v-btn>
                  </v-card-actions>
                  <!-- <pre>{{editedItem}}</pre>  -->
                </v-card>
            </v-dialog>
          </v-toolbar> 
          <br>
          <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar Frase"
          single-line
          class="text-field"
          color="#111c3d"
          ></v-text-field>
          <br>
          <v-data-table 
          :headers="headers" 
          :items="frases" 
          :search="search"
          style=" border: 2px solid #111c3d;"
          class="elevation-3"
          >
          <!-- tabla donde se pintan los datos obtenidos del arreglo -->
          <template v-slot:no-data>
            <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>No se encontro su busqueda</v-alert>
          </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
          v-model="snackbar"
          :bottom="y === 'bottom'"
          :left="x === 'left'"
          :multi-line="mode === 'multi-line'"
          :right="x === 'right'"
          :timeout="timeout"
          :top="y === 'top'"
          :vertical="mode === 'vertical'"
          color="#3945d0"
          style="color:white"
          >
          {{ text }}
          <v-btn color="#3945d0" depressed @click="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      frases:[],
      dialog: false,
      headers: [
        {
          text: "Frase",
          value: "cc_frase",
          align: "center",
          class:"column"
        }
      ],
      defaultItem: {
        id: "",
        frase: "",
        /* fechaI:"",
        fechaN:"", */
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        frase: "",
        /* fechaI:"",
        fechaN:"", */
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Frase" : "Editar Usuario";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    this.obtenerTodo();
  },

  methods: {    

  /**
   * Metodo para obtener areas
   */
    obtenerTodo() {
      axios.get(`${env.endpoint}callcenter/frasestodos`).then(res => (this.frases = res.data));
    },

  /**
   * Metodo para agregar fila de la tabla en la modal
   */
    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

  /**
   * Metodo para cerrar la modal
   */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

  /**
   * Metodo para guardar y actualizar
   */
    save() {
        // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
        const nuevaFrase = JSON.stringify({
          frase: this.editedItem.frase,
          /* fechaI:"",
          fechaN:"", */
        });        
        // se crea la area
        axios
          .get(`${env.endpoint}callcenter/create_frase?frase=${nuevaFrase}`)
          .then(res => {
            if (res.data.mensaje === "frase registrada") {
              (this.snackbar = true),
                (this.text = "Frase registrada satisfactoriamente");
            } else if (res.data.mensaje === "error en el registro") {
              (this.snackbar = true), (this.text = "Error al registrar");
            } else if (res.data.mensaje === "error usuario existe") {
              (this.snackbar = true),
                (this.text = "El usuario ya existe en la plataforma");
            }
            // console.log(nuevoUsuario);
          });
      this.close(), this.obtenerTodo(); 
    }
  }
};
</script>